import { render, staticRenderFns } from "./IngestedBadge.vue?vue&type=template&id=7adc43d2&scoped=true"
import script from "./IngestedBadge.vue?vue&type=script&lang=js"
export * from "./IngestedBadge.vue?vue&type=script&lang=js"
import style0 from "./IngestedBadge.vue?vue&type=style&index=0&id=7adc43d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adc43d2",
  null
  
)

export default component.exports